import {
  BulkActionContainerCol,
  Button,
  Col,
  Table,
  TableActionBarRow,
} from "melco-ui";
import { useTranslation } from "react-i18next";
import {
  BulkActionCount,
  FormattedDate,
  ReportingMelcoMachineStatisticsModelsMachineDesignListItem,
  Search,
  useTableSelection,
} from "melco-shared-logic";
import { useDesigns } from "../../../../hooks/reporting/useDesigns";
import { BulkActionAddFilterDesigns } from "./BulkActionAddFilterDesigns";

export type FiltersDesignsListProps = {
  designsFilter: any;
  setDesignsFilter: any;
};

export const FiltersDesignsList: React.FC<FiltersDesignsListProps> = ({
  designsFilter,
  setDesignsFilter,
}) => {
  const { t } = useTranslation();
  let { data, pagination, onTableConfigChange, searchQueryChange } =
    useDesigns();

  const handleAddRemove = (file_name: string) => {
    if (isFilterAlreadyAdded(file_name)) {
      setDesignsFilter(
        designsFilter.filter((selectedObj: any) => {
          return selectedObj.label !== file_name;
        })
      );
    } else {
      setDesignsFilter([
        ...designsFilter,
        { label: file_name, value: file_name },
      ]);
    }
    //  setSelectedRowKeys([]);
  };

  const isFilterAlreadyAdded = (file_name: string) => {
    return designsFilter?.find((c: any) => {
      return c.label == file_name;
    });
  };

  const columns = [
    {
      title: t(
        "reporting.statistics.filters.design.add.list.columns.file_name"
      ),
      key: "file_name",
      dataIndex: "file_name",
      sorter: true,
    },
    {
      title: t(
        "reporting.statistics.filters.design.add.list.columns.sew_count"
      ),
      key: "sew_count",
      dataIndex: "sew_count",
      sorter: true,
    },
    {
      title: t(
        "reporting.statistics.filters.design.add.list.columns.last_sew_date"
      ),
      key: "last_sew_date",
      sorter: true,
      render: (
        item: ReportingMelcoMachineStatisticsModelsMachineDesignListItem
      ) => <FormattedDate date={item.last_sew_date} />,
    },
    {
      align: "right" as const,
      render: (
        rowObj: ReportingMelcoMachineStatisticsModelsMachineDesignListItem
      ) => {
        return isFilterAlreadyAdded(rowObj?.file_name ?? "") ? (
          <Button onClick={() => handleAddRemove(rowObj?.file_name ?? "")}>
            {t("reporting.statistics.filters.design.add.list.columns.deselect")}
          </Button>
        ) : (
          <Button
            type="primary"
            onClick={() => handleAddRemove(rowObj?.file_name ?? "")}
          >
            {t("reporting.statistics.filters.design.add.list.columns.select")}
          </Button>
        );
      },
    },
  ];

  const { selectedRowKeys, setSelectedRowKeys, rowSelection, onRow } =
    useTableSelection<ReportingMelcoMachineStatisticsModelsMachineDesignListItem>(
      () => {}
    );

  return (
    <>
      <TableActionBarRow>
        <Col>
          <Search
            onSearchInputChange={(query: string) => searchQueryChange(query)}
          />
        </Col>
        <BulkActionContainerCol>
          <BulkActionCount selectedCount={selectedRowKeys.length} />
          <BulkActionAddFilterDesigns
            allDesigns={data}
            selectedRowKeys={selectedRowKeys}
            setSelectedRowKeys={setSelectedRowKeys}
            setDesignsFilter={setDesignsFilter}
            designsFilter={designsFilter}
          />
        </BulkActionContainerCol>
      </TableActionBarRow>
      <Table
        dataSource={data}
        columns={columns}
        rowKey="file_name"
        onRow={onRow}
        rowSelection={rowSelection}
        onChange={onTableConfigChange}
        pagination={pagination}
      />
    </>
  );
};
